/**
 * An organization's Rules — `policy.rules` in its settings: whether a merge in
 * its workspaces waits for an audit.
 *
 *   requireAudit  a session in one of its workspaces is not merged until the
 *                 Rules audit of its current change has run — an audit that
 *                 found an enforced MUST violated holds it either way
 *
 * The rules themselves are each workspace's, versioned in its rules repository
 * (`config.rulesRepository`, `rules/repository.ts`). An organization named a
 * rules repository of its own here until 2026-10-23; the owner took it out to
 * start from the workspace's alone, and a stored `repository` is read as
 * nothing.
 *
 * In the policy for the reason the pull-request rules are: a rule a member's
 * machine could clear is no rule. It reaches the organization's own
 * workspaces only. Rules are a Team and Enterprise feature; an organization
 * is on one of the two by being one, so nothing here asks which.
 */
import { isPlainObject } from '../workspace/shape';

export interface OrgRules {
  requireAudit: boolean;
}

export const EMPTY_ORG_RULES: OrgRules = { requireAudit: false };

/** As a stored document carries it: a section that does not read is no rule rather than a failure. */
export function orgRulesOf(raw: unknown): OrgRules {
  if (!isPlainObject(raw)) return EMPTY_ORG_RULES;
  return { requireAudit: raw.requireAudit === true };
}

/** As an administrator wrote it — refused with a sentence per fault, never filtered. */
export function parseOrgRules(input: unknown, problems: string[]): OrgRules {
  if (input === undefined || input === null) return EMPTY_ORG_RULES;
  const at = 'policy.rules';
  if (!isPlainObject(input)) {
    problems.push(`${at}: Expected an object.`);
    return EMPTY_ORG_RULES;
  }
  for (const key of Object.keys(input)) if (key !== 'requireAudit') problems.push(`${at}.${key}: Not a field this version of Airlock knows.`);
  if (input.requireAudit !== undefined && typeof input.requireAudit !== 'boolean') problems.push(`${at}.requireAudit: Expected true or false.`);
  return { requireAudit: input.requireAudit === true };
}
